export const tourData = [
  {
    id: 1,
    city: "new york",
    img: "./img/newyork.jpeg",
    name: "new york bridge tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 2,
    city: "paris",
    img: "./img/paris.jpeg",
    name: "paris lights tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 3,
    city: "london",
    img: "./img/london.jpeg",
    name: "london royal palace tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  },
  {
    id: 4,
    city: "tokyo",
    img: "./img/tokyo.jpeg",
    name: "tokyo sushi tour",
    info:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Vel,repellendus!"
  }
];
